import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';

//TYPES
type Props = {
  label: string;
  subtitleLabel?: string;
  size?: 'h5' | 'h6';
  onBack?: () => void;
};

const Title: FC<Props> = ({label, size = 'h5', onBack, subtitleLabel}) => {
  return (
    <Stack direction="column" sx={styles.container}>
      <Stack direction="row" sx={styles.titleContainer}>
        {onBack && (
          <IconButton sx={{color: 'common.white'}} onClick={onBack}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant={size} sx={styles.title}>
          {label}
        </Typography>
      </Stack>
      {subtitleLabel && (
        <Typography variant="body2" sx={styles.subTitle}>
          {subtitleLabel}
        </Typography>
      )}
    </Stack>
  );
};
export default Title;

const styles: Record<string, SxProps> = {
  container: {
    mb: '0.5rem',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 1,
  },
  title: {
    color: 'primary.main',
    backgroundColor: 'rgba(0,0,0,0)',
    p: 0,
  },
  subTitle: {
    color: 'grey.700',
    backgroundColor: 'rgba(0,0,0,0)',
  },
};
